/* nc-comparateur — comparaison interactive de 2 conteneurs.
   2 combobox recherchables (façon sélecteur devis). Les jumeaux neuf/occasion
   sont REGROUPÉS : 1 entrée = 1 modèle (jamais l'état affiché). Le comparatif
   prend les caractéristiques du PREMIER VOYAGE. Aucun fetch. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__ncComparateurInit) return;
    var dataEl = root.querySelector('[data-nc-comparateur-data]');
    if (!dataEl) return;
    var products;
    try { products = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(products)) return;
    products = products.filter(function (p) { return p && p.handle; });
    if (products.length < 2) return;
    root.__ncComparateurInit = true;

    var labels = {
      ctaView: root.getAttribute('data-cta-view') || 'Voir le produit',
      ctaDevis: root.getAttribute('data-cta-devis') || 'Demander un devis',
      na: root.getAttribute('data-na') || '—',
      noResult: root.dataset.lang === 'en' ? 'No container found' : 'Aucun conteneur trouvé'
    };
    var devisUrl = root.getAttribute('data-devis-url') || '/pages/faire-un-devis';

    /* ---- Regroupement des jumeaux en « modèles » (clé type|titre nettoyé) ---- */
    var modelsByKey = {};
    var modelOrder = [];
    var byHandle = {};  // handle produit -> clé modèle (pour le deep-link)

    products.forEach(function (p) {
      var type = p.type || '';
      var key = type + '|' + (cleanLabel(p.title, type) || p.handle);
      var model = modelsByKey[key];
      if (!model) {
        model = modelsByKey[key] = {
          key: key, type: type, famille: p.famille || '',
          label: cleanLabel(p.title, type) || p.title, image: p.image || '', etats: {}
        };
        modelOrder.push(model);
      }
      var etat = p.etat || 'na';
      model.etats[etat] = p;
      byHandle[p.handle] = key;
      // référence d'affichage = premier voyage si dispo
      if (etat === 'premier-voyage') {
        model.label = cleanLabel(p.title, type) || p.title;
        if (p.image) model.image = p.image;
      } else if (!model.image && p.image) {
        model.image = p.image;
      }
    });

    modelOrder.sort(function (a, b) {
      var fa = prettyFamille(a.famille || a.type), fb = prettyFamille(b.famille || b.type);
      if (fa !== fb) return fa.localeCompare(fb, 'fr');
      return a.label.localeCompare(b.label, 'fr');
    });

    function refProduct(model) {
      if (!model) return null;
      return model.etats['premier-voyage'] || model.etats[Object.keys(model.etats)[0]];
    }

    var state = { a: null, b: null };  // clés de modèle
    var combos = { a: buildCombo('a'), b: buildCombo('b') };

    /* ---- Combobox single-select (sur les modèles) ---- */
    function buildCombo(side) {
      var wrap = root.querySelector('[data-ac="' + side + '"]');
      if (!wrap) return null;
      var input = wrap.querySelector('[data-ac-input]');
      var list = wrap.querySelector('[data-ac-list]');
      var base = input.id || ('nc-cmp-' + side);
      var activeIdx = -1;
      var emptyEl = null;

      modelOrder.forEach(function (m, i) {
        var li = document.createElement('li');
        li.id = base + '-opt-' + i;
        li.className = 'nc-comparateur__ac-opt';
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        li.setAttribute('data-key', m.key);
        li.innerHTML = optionMarkup(m);
        li.addEventListener('mousedown', function (e) { e.preventDefault(); choose(side, m.key); });
        list.appendChild(li);
      });

      function options() { return Array.prototype.slice.call(list.querySelectorAll('.nc-comparateur__ac-opt')); }
      function visible() { return options().filter(function (li) { return !li.hidden; }); }
      function open() { wrap.classList.add('is-open'); input.setAttribute('aria-expanded', 'true'); }
      function close() { wrap.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); activeIdx = -1; clearActive(); }
      function clearActive() {
        options().forEach(function (li) { li.classList.remove('is-active'); });
        input.setAttribute('aria-activedescendant', '');
      }
      function filter() {
        var q = input.value.trim().toLowerCase();
        var any = false;
        options().forEach(function (li) {
          var m = modelsByKey[li.getAttribute('data-key')];
          var hay = ((m.label || '') + ' ' + (m.type || '') + ' ' + prettyFamille(m.famille || '')).toLowerCase();
          var show = !q || hay.indexOf(q) !== -1;
          li.hidden = !show;
          if (show) any = true;
        });
        if (!any && !emptyEl) {
          emptyEl = document.createElement('li');
          emptyEl.className = 'nc-comparateur__ac-empty';
          emptyEl.setAttribute('aria-disabled', 'true');
          emptyEl.textContent = labels.noResult;
          list.appendChild(emptyEl);
        }
        if (emptyEl) emptyEl.hidden = any;
      }
      function setActive(idx) {
        clearActive();
        var vis = visible();
        if (idx < 0 || idx >= vis.length) { activeIdx = -1; return; }
        activeIdx = idx;
        vis[idx].classList.add('is-active');
        input.setAttribute('aria-activedescendant', vis[idx].id);
        vis[idx].scrollIntoView({ block: 'nearest' });
      }

      input.addEventListener('focus', function () { filter(); open(); });
      input.addEventListener('click', function () { filter(); open(); });
      input.addEventListener('input', function () { filter(); open(); activeIdx = -1; });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); if (!wrap.classList.contains('is-open')) { filter(); open(); } setActive(activeIdx + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIdx - 1); }
        else if (e.key === 'Enter') { var vis = visible(); if (activeIdx >= 0 && vis[activeIdx]) { e.preventDefault(); choose(side, vis[activeIdx].getAttribute('data-key')); } }
        else if (e.key === 'Escape') { close(); input.blur(); }
      });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });

      return {
        setValue: function (label) { input.value = label || ''; },
        close: close,
        markSelected: function (key) {
          options().forEach(function (li) {
            var sel = li.getAttribute('data-key') === key;
            li.classList.toggle('is-selected', sel);
            li.setAttribute('aria-selected', sel ? 'true' : 'false');
          });
        }
      };
    }

    function optionMarkup(m) {
      var img = m.image ? '<img src="' + escapeAttr(m.image) + '" alt="" width="48" height="48" loading="lazy" decoding="async">' : '';
      var type = m.type ? '<span class="nc-comparateur__ac-type">' + escapeHtml(m.type) + '</span>' : '';
      return '<span class="nc-comparateur__ac-thumb">' + img + '</span>' +
             '<span class="nc-comparateur__ac-info"><span class="nc-comparateur__ac-name">' + escapeHtml(m.label || '') + '</span>' + type + '</span>';
    }

    function choose(side, key) {
      if (!modelsByKey[key]) return;
      var other = side === 'a' ? 'b' : 'a';
      if (state[other] === key) { var alt = firstDifferent(key); if (alt) setSide(other, alt); }
      setSide(side, key);
      if (combos[side]) combos[side].close();
      // À partir d'une vraie sélection utilisateur, on autorise l'écriture de l'URL (partage / deep-link).
      userInteracted = true;
      render();
    }

    function setSide(side, key, fillInput) {
      state[side] = key;
      var m = modelsByKey[key];
      if (combos[side]) {
        // fillInput === false : on garde le champ vide (placeholder) tout en
        // sélectionnant le modèle (utilisé pour la sélection par défaut au chargement).
        if (fillInput !== false) combos[side].setValue(m ? m.label : '');
        combos[side].markSelected(key);
      }
    }

    function firstDifferent(key) {
      for (var i = 0; i < modelOrder.length; i++) { if (modelOrder[i].key !== key) return modelOrder[i].key; }
      return null;
    }

    /* Ne réécrit l'URL qu'après une interaction utilisateur (pas au chargement par
       défaut) : la home reste propre pour un simple visiteur, le deep-link/partage
       reste actif dès qu'on choisit un conteneur. */
    var userInteracted = false;

    /* ---- Sélection initiale (URL ?a=&b= : handle produit -> modèle) ---- */
    var params = new URLSearchParams(window.location.search);
    var defA = root.getAttribute('data-default-a') || '';
    var defB = root.getAttribute('data-default-b') || '';
    var ka = byHandle[params.get('a')] || byHandle[defA] || modelOrder[0].key;
    setSide('a', ka, false);
    var kb = byHandle[params.get('b')] || byHandle[defB];
    setSide('b', (kb && kb !== state.a) ? kb : firstDifferent(state.a), false);

    var controls = root.querySelector('[data-controls]'); if (controls) controls.removeAttribute('hidden');
    var diffbar = root.querySelector('[data-diffbar]'); if (diffbar) diffbar.removeAttribute('hidden');

    var board = root.querySelector('[data-board]');
    var diffOnly = root.querySelector('[data-diff-only]');
    if (diffOnly && board) diffOnly.addEventListener('change', function () { board.classList.toggle('is-diff-only', diffOnly.checked); });

    render();
    document.addEventListener('nc:design-preview:change', render);

    /* ---- Rendu ---- */
    function render() { renderHead('a'); renderHead('b'); renderRows(); updateUrl(); }

    function renderHead(side) {
      var head = root.querySelector('[data-head="' + side + '"]');
      var m = modelsByKey[state[side]];
      var prod = refProduct(m);
      if (!head || !m || !prod) return;
      var thumb = head.querySelector('[data-thumb]');
      if (thumb) {
        thumb.innerHTML = '';
        if (m.image) {
          var img = document.createElement('img');
          img.src = m.image; img.alt = m.label || '';
          img.width = 600; img.height = 400; img.loading = 'lazy'; img.decoding = 'async';
          thumb.appendChild(img);
        }
      }
      var fam = head.querySelector('[data-famille]');
      if (fam) {
        var f = prettyFamille(m.famille || m.type);
        if (f) { fam.textContent = f; fam.removeAttribute('hidden'); } else { fam.textContent = ''; fam.setAttribute('hidden', ''); }
      }
      var name = head.querySelector('[data-name]');
      var pilot = Boolean(document.querySelector('[data-nc-design-preview="home"]'));
      if (name) {
        name.textContent = '';
        appendLabel(name, m.label || '', (m.label || '').replace(/^conteneur[s]?\s+/i, ''), pilot);
      }
      var view = head.querySelector('[data-cta-view]');
      if (view) { view.href = prod.url; setAction(view, labels.ctaView, root.dataset.lang === 'en' ? 'Details' : 'Fiche', prod.title, pilot); }
      var devis = head.querySelector('[data-cta-devis]');
      if (devis) { devis.href = devisUrl + '?produit=' + encodeURIComponent(prod.handle); setAction(devis, labels.ctaDevis, root.dataset.lang === 'en' ? 'Quote' : 'Devis', prod.title, pilot); }
    }

    function appendLabel(parent, full, short, pilot) {
      var original = document.createElement('span');
      original.className = 'nc-comparateur__label-full';
      original.textContent = full;
      parent.appendChild(original);
      if (!pilot) return;
      var compact = document.createElement('span');
      compact.className = 'nc-comparateur__label-short';
      compact.setAttribute('aria-hidden', 'true');
      compact.textContent = short;
      parent.appendChild(compact);
    }

    function setAction(link, full, short, title, pilot) {
      link.textContent = '';
      link.setAttribute('aria-label', full + ' — ' + title);
      appendLabel(link, full, short, pilot);
    }

    function renderRows() {
      var rows = root.querySelectorAll('[data-rows] [data-spec-key]');
      var pa = refProduct(modelsByKey[state.a]), pb = refProduct(modelsByKey[state.b]);
      rows.forEach(function (row) {
        var key = row.getAttribute('data-spec-key');
        var va = getValue(pa, key), vb = getValue(pb, key);
        setCell(row.querySelector('[data-cell="a"]'), va, key);
        setCell(row.querySelector('[data-cell="b"]'), vb, key);
        row.classList.toggle('is-diff', normalize(va) !== normalize(vb));
      });
    }

    function setCell(cell, val, key) {
      if (!cell) return;
      if (val == null || val === '') cell.innerHTML = '<span class="nc-comparateur__na">' + escapeHtml(labels.na) + '</span>';
      else {
        cell.textContent = val;
        if (!document.querySelector('[data-nc-design-preview="home"]') || !/^(dimensions_ext|dimensions_int|passage_porte)$/.test(key)) return;
        var parts = String(val).split(/\s*[×x]\s*/i);
        var door = key === 'passage_porte';
        if (parts.length !== (door ? 2 : 3)) return;
        var axes = root.dataset.lang === 'en' ? ['L', 'W', 'H'] : ['L', 'l', 'H'];
        if (door) axes.shift();
        cell.textContent = '';
        var full = document.createElement('span');
        full.className = 'nc-comparateur__value-full';
        full.textContent = val;
        cell.appendChild(full);
        var dimensions = document.createElement('span');
        dimensions.className = 'nc-comparateur__dimensions';
        dimensions.setAttribute('aria-hidden', 'true');
        parts.forEach(function (part, index) {
          var axis = document.createElement('span');
          axis.className = 'nc-comparateur__dimension';
          var label = document.createElement('span');
          label.className = 'nc-comparateur__axis';
          label.textContent = axes[index];
          var value = document.createElement('span');
          value.textContent = part;
          axis.append(label, value);
          dimensions.appendChild(axis);
        });
        cell.appendChild(dimensions);
      }
    }

    function getValue(prod, key) {
      if (!prod) return '';
      if (key === 'certifications') { var c = prod.certifications; return (c && c.length) ? c.join(' ; ') : ''; }
      if (key === 'type') return prod.type || '';
      return (prod.specs && prod.specs[key]) || '';
    }

    function updateUrl() {
      try {
        if (!userInteracted) return;
        var pa = refProduct(modelsByKey[state.a]), pb = refProduct(modelsByKey[state.b]);
        if (!pa || !pb) return;
        var sp = new URLSearchParams(window.location.search);
        sp.set('a', pa.handle); sp.set('b', pb.handle);
        window.history.replaceState(null, '', window.location.pathname + '?' + sp.toString());
      } catch (e) { /* no-op */ }
    }
  }

  /* ---- Helpers ---- */
  function cleanLabel(title, type) {
    if (!title) return type || '';
    var t = title
      .replace(/premier[\s-]?voyage/ig, '')
      .replace(/1er[\s-]?voyage/ig, '')
      .replace(/\boccasion\b/ig, '')
      .replace(/\bneuf\b/ig, '')
      .replace(/[\s–—-]+$/g, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
    return t || title;
  }
  function prettyFamille(f) {
    if (!f) return '';
    return f.replace(/[-_]+/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }).trim();
  }
  function normalize(v) { return (v == null ? '' : String(v)).trim().toLowerCase(); }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  function initAll(scope) { (scope || document).querySelectorAll('[data-nc-comparateur]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
